// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__z4o8f","toggle":"Timer_toggle__-HFP9"};